import useSWR from "swr";
import { packageUrls } from "../../../Api/Auth/ApiUrls";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";
import Tabs from "../../../Components/Common/Tabs";
import { tutoringPagesTabsData } from "../../../data/SidebarData";
import { useAuth } from "../../../Context/AuthContext";
import { one2OneTutoring } from "../../../Api/Auth/AppUrls";

const TutoringIndex = () => {
  const { data } = useSWR(packageUrls.list(""));
  const { userData } = useAuth();
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs
        tabs={
          userData?.roleId === 6
            ? tutoringPagesTabsData.filter(
                (item) => item.path !== one2OneTutoring.purchase
              )
            : tutoringPagesTabsData
        }
      />
      <StaticPageForm
        title="Tutoring"
        typeData={data}
        type="packages"
        category="civil"
        promo
      />
    </div>
  );
};

export default TutoringIndex;
